export default {
    marketingCampaigns(state) {
        return state.marketingCampaigns;
    },
    activeMarketingCampaign(state) {
        return state.activeMarketingCampaign;
    },
    loadingMarketingCampaigns(state) {
        return state.loadingMarketingCampaigns;
    },
    requestingResource(state) {
        return state.requestingResource;
    },
    errors(state) {
        return state.errors;
    }
}